var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basic icons "
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58807 0.815002C5.68169 0.719502 5.8098 0.666016 5.94284 0.666016H9.07181C10.4318 0.666016 11.5356 1.78552 11.5356 3.16602C12.8956 3.16602 13.9993 4.28552 13.9993 5.66602V12.166C13.9993 13.5465 12.8956 14.666 11.5356 14.666H7.59355C6.23355 14.666 5.12978 13.5465 5.12978 12.166C3.76978 12.166 2.66602 11.0465 2.66602 9.66602V4.02951C2.66602 3.89801 2.71531 3.77203 2.80893 3.67853L5.58807 0.815002ZM10.5501 3.16602V9.66602C10.5501 10.4945 9.88978 11.166 9.07181 11.166H5.12978C4.31181 11.166 3.65152 10.4945 3.65152 9.66602V5.16602H6.60804C6.87906 5.16602 7.1008 4.94202 7.1008 4.66602V1.66602H9.07181C9.88978 1.66602 10.5501 2.33752 10.5501 3.16602ZM6.11529 1.69901V4.16602H3.72052L6.11529 1.69901ZM7.59355 13.666C6.77558 13.666 6.11529 12.9945 6.11529 12.166H9.07181C10.4318 12.166 11.5356 11.0465 11.5356 9.66602V4.16602C12.3536 4.16602 13.0138 4.83752 13.0138 5.66602V12.166C13.0138 12.9945 12.3536 13.666 11.5356 13.666H7.59355Z",
    fill: "#70808F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.319571ec9be39bc5f1dd6bb34b8e4a7e.svg";
export { ForwardRef as ReactComponent };